import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';

import {
  Field,
  GetStaticComponentProps,
  useComponentProps,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { defaultLanguage } from 'temp/config';
import { ArticleCardData } from 'model/Article';
import ArticlesSectionComponent from './ArticlesSectionComponent';
import { useI18n } from 'next-localization';
import { articleService } from 'lib/services/ArticleService';
import RelatedArticleTile from 'components/Tiles/RelatedArticleTile';

type FeaturedArticlesSectionFields = {
  viewAll?: Field<string>;
  baseUrl?: Field<string>;
  featuredArticles: Field<string[]>;
};

type FeaturedArticlesSectionProps = ComponentProps & {
  fields?: FeaturedArticlesSectionFields;
};

const FeaturedArticlesSection: React.FC<FeaturedArticlesSectionProps> = ({ fields, rendering }) => {
  const articles = useComponentProps<ArticleCardData[]>(rendering.uid);
  const { t } = useI18n();

  if (!articles?.length) return null;

  return (
    <ArticlesSectionComponent
      rendering={rendering}
      articles={articles}
      viewAllSrc={fields?.viewAll?.value}
      sectionTitle={t('featuredArticlesTitle')}
      backgroundColor={rendering.params?.backgroundColor}
      sliderCardComponent={RelatedArticleTile}
    />
  );
};

export const getStaticProps: GetStaticComponentProps = async (rendering, layoutData) => {
  const fields = rendering.fields as unknown as FeaturedArticlesSectionFields;
  const siteId = layoutData.sitecore.context?.siteRoot;
  const language = layoutData.sitecore.context.language ?? defaultLanguage;
  const { featuredArticles } = fields;

  if (!featuredArticles.value?.length) return [];
  return await articleService.getFeaturedArticles(language, siteId, featuredArticles.value);
};
export default FeaturedArticlesSection;
